"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var clampNumber_1 = __importDefault(require("./clampNumber"));
/**
 * Considers the given boundaries of the track left and right (maxScrollPosLeft = 0 & maxScrollPosRight).
 * Returns either maxScrollPosRight, the given newPosX or 0
 * maxScrollPosRight should be negative as the Slider slides to the left.
 * @param newPosX scroll position X that should be set
 */
var considerBoundaries = function (newPosXValue, maxScrollPosRight) {
    if (maxScrollPosRight >= 0)
        return 0; // Less sliderItems than slider can show
    return clampNumber_1.default(newPosXValue, maxScrollPosRight, 0);
};
exports.default = considerBoundaries;
//# sourceMappingURL=considerBoundaries.js.map